'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2016/9/14.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalCenterNew = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('联系我们')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalCenterNew, _Component);

  function PersonalCenterNew() {
    (0, _classCallCheck3.default)(this, PersonalCenterNew);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalCenterNew).call(this));

    _this.state = {
      hoverIndex: -1
    };
    return _this;
  }

  (0, _createClass3.default)(PersonalCenterNew, [{
    key: 'onLiMouseAction',
    value: function onLiMouseAction(index) {
      this.setState({
        hoverIndex: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ContactUs.scss');
      var location = this.props.location;
      var hoverIndex = this.state.hoverIndex;

      var menuArray = [{
        text: '关于艺品网',
        url: '/contactus/about',
        activeUrl: '/contactus/about'
      }, {
        text: '联系我们',
        url: '/contactus/callus',
        activeUrl: '/contactus/callus'
      }, {
        text: '免责声明',
        url: '/contactus/standarddisclaimer',
        activeUrl: '/contactus/standarddisclaimer'
      }, {
        text: '承诺声明',
        url: '/contactus/assuredeclare',
        activeUrl: '/contactus/assuredeclare'
      }, {
        text: '法律声明',
        url: '/contactus/legalstatement',
        activeUrl: '/contactus/legalstatement'
      }];
      var carouselOfContactUsTitle = [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/01.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/02.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/03.jpg'
      }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.tackImg },
          _react2.default.createElement(_components.GoeasyCarousel, { page: 'productsListMiddle', style: { width: 1280, height: 213 }, images: carouselOfContactUsTitle })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.leftBar },
          _react2.default.createElement(
            'div',
            { className: styles.personalInfo },
            _react2.default.createElement(
              'h3',
              null,
              '您好，',
              _react2.default.createElement('br', null),
              '欢迎来到 ',
              _react2.default.createElement(
                'span',
                { className: styles.red },
                '艺品网'
              )
            )
          ),
          _react2.default.createElement(
            'ul',
            { className: styles.menu },
            menuArray.map(function (item, index) {
              var currentClassName = styles['back' + (index + 1)];
              if (item.activeUrl && item.activeUrl !== '' && location.pathname.indexOf(item.activeUrl) > -1) {
                currentClassName = currentClassName + ' ' + styles.active;
              } else if (hoverIndex === index) {
                currentClassName = currentClassName + ' ' + styles.active;
              }
              return _react2.default.createElement(
                'li',
                { key: index, className: currentClassName, onMouseOut: function onMouseOut() {
                    return _this2.onLiMouseAction(-1);
                  },
                  onMouseOver: function onMouseOver() {
                    return _this2.onLiMouseAction(index);
                  } },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: item.url },
                  _react2.default.createElement('i', {
                    className: styles['ic' + (index + 1)] }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.text
                  )
                )
              );
            })
          ),
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/dianbg7.jpg', alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.rightContent },
          _react2.default.createElement('div', { className: 'clear' }),
          this.props.children
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return PersonalCenterNew;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PersonalCenterNew;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ContactUs/ContactUs.js
 ** module id = 1454
 ** module chunks = 0
 **/